import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const forYou = ['Latina USA 25-45 con 1-3 hijos posparto 6-36 meses', 'Frustrada tacto panza flácida espejo diario', 'Doble carga: trabajo + casa, 0 tiempo gym', 'Intentó 2+ dietas sin resultados', 'Alta culpa Instagram vs realidad', 'Quiere abdomen firme rápido, sostenible'];
  const notForYou = ['Menos 6 meses post-parto (espera clearance médico)', 'Quiere dieta extrema/suplementos caros', 'Puede gym 5 días/semana', 'Pre-embarazo o sin niños', 'Busca six-pack influencer (esto es real posparto)'];
  return <Section className="bg-white" data-id="element-177">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-178">
        {/* For You */}
        <div className="bg-green-50/50 border border-green-100 rounded-2xl p-8" data-id="element-179">
          <h3 className="text-2xl font-bold text-[#0D5C63] mb-6 font-serif flex items-center" data-id="element-180">
            <span className="bg-green-100 p-2 rounded-full mr-3" data-id="element-181">
              <Check className="w-6 h-6 text-green-700" data-id="element-182" />
            </span>
            Esto ES Para Ti Si...
          </h3>
          <ul className="space-y-4" data-id="element-183">
            {forYou.map((item, index) => <li key={index} className="flex items-start text-gray-700" data-id="element-184">
                <Check className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-185" />
                <span data-id="element-186">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-red-50/50 border border-red-100 rounded-2xl p-8" data-id="element-187">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 font-serif flex items-center" data-id="element-188">
            <span className="bg-red-100 p-2 rounded-full mr-3" data-id="element-189">
              <X className="w-6 h-6 text-red-700" data-id="element-190" />
            </span>
            Esto NO Es Para Ti Si...
          </h3>
          <ul className="space-y-4" data-id="element-191">
            {notForYou.map((item, index) => <li key={index} className="flex items-start text-gray-600" data-id="element-192">
                <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-193" />
                <span data-id="element-194">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}